import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import ProjectCard, { ProjectCardProps } from '@/components/base/ProjectCard'

import { projectGridRevealAnimation } from './animations'
import { Section } from '@/types'

type ProjectGridProps = Section & {
  collection?: ProjectCardProps[]
}

const ProjectGrid = ({ collection, ...props }: ProjectGridProps) => {
  return (
    <Motion animation={projectGridRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-sm">
              {collection?.map((project) => (
                <div
                  key={`project-card-${project.uuid}`}
                  className="col-span-2 md:col-span-3 lg:col-span-6"
                >
                  <ProjectCard {...project} />
                </div>
              ))}
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default ProjectGrid
